import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import Panel from './Panel';

const dotJoin = (parts) => parts.filter(Boolean).join(' · ');

const tokenBreakdown = ({ inputTokens, outputTokens, outputTokenDetails }) => dotJoin([
    `in ${inputTokens}`,
    `out ${outputTokens}`,
    outputTokenDetails?.reasoningTokens && `thinking ${outputTokenDetails.reasoningTokens}`,
]);

const settingsUsed = ({ hintLegalMoves, thinkingLevel, fallback, model }) => dotJoin([
    hintLegalMoves ? 'cells listed' : 'cells unlisted',
    thinkingLevel,
    fallback === false && 'no fallback',
    model,
]);

const MoveLog = ({ moves }) => {
    const totalTokens = moves.reduce((sum, { usage }) => sum + (usage?.totalTokens ?? 0), 0);

    return (
        <Panel
            title="How the model moved"
            aside={totalTokens > 0 && (
                <Typography variant="caption" color="text.secondary">{totalTokens} tokens</Typography>
            )}
        >
            {moves.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                    Make a move and the model&rsquo;s answer appears here, with what it cost.
                </Typography>
            ) : (
                <Stack spacing={2} divider={<Divider flexItem />} aria-live="polite">
                    {moves.map((move, index) => (
                        <Box key={`${index}-${move.cell}`}>
                            <Typography variant="body2" sx={{ fontWeight: 700 }} color={move.illegal ? 'error' : undefined}>
                                {move.illegal
                                    ? `${move.mark} tried cell ${move.cell}, which was taken`
                                    : `${move.mark} takes cell ${move.cell}`}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                                {move.reason}
                            </Typography>
                            {move.usage && (
                                <Typography variant="caption" color="text.disabled" sx={{ display: 'block', mt: 0.75 }}>
                                    {tokenBreakdown(move.usage)}
                                </Typography>
                            )}
                            <Typography variant="caption" color="text.disabled" sx={{ display: 'block' }}>
                                {settingsUsed(move)}
                            </Typography>
                        </Box>
                    ))}
                </Stack>
            )}
        </Panel>
    );
};

export default MoveLog;
